export default "__VITE_ASSET__10dfc4c9__"